<template>
    <div class="row" style="" >
      <div class="chart-wrapper" id="comparison-chart">
        <div class="chart-title">
          <div class="col-md-12 bg-primary">
            <div class="col-md-12 text-center car_table_header">

              <label class="table-label" style="font-weight: normal; flex-basis: 80%; padding-left: 15px;">
              Comparison of <b>{{indicatorSelected}}</b> in <b> {{theName}} </b>  across different data sources
              </label>

              <div class="col-xs-2 web-features line-chart-options" data-step="6" data-intro='<b>Changing Chart view</b><p>Click on your preferred chart type</p>'>
                <div @click="changeChart('line')" class="col-xs-6 line-chart-option" style="" :class="{'chart-option-selected': lineSelected}">
                  <span style="">LINE</span>
                  <v-icon style="font-size: 14px;">show_chart</v-icon>
                </div>
                <div @click="changeChart('column')" class="col-xs-6 line-chart-option" style="" :class="{'chart-option-selected': columnSelected}">
                  <span style="">COLUMN</span>
                  <v-icon style="font-size: 14px;">bar_chart</v-icon>
                </div>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
        <div class="chart-title title_placement" style="background: #DFF3F3;">
            <div class="row" id="lineLabelToggle">

                <div class="hidden">
                    {{sourceClicked}} {{stateSelected}}
                </div>


          <div class="hidden">
            {{sourceClicked}} {{stateSelected}}
          </div>

        </div>

      </div>

      <div v-if="nhmisMonthlyAlert" style="border: 2px #24397D dashed; border-radius:7px; margin-top:40px; margin-left:30px; margin-right:30px; background: #F3F9FF 0% 0% no-repeat padding-box;">
          <p style="font-size:80%; padding:7px; font-family: Open Sans; font-size:12px">
            <span>
              <img src="static\img\icons\nhmis-analysis.svg" alt="" width="22.5px">
            </span>
          <span style="color:#24397D; font-weight:600">For more detailed NHMIS monthly data analysis, please visit the
            <a href="https://msdat.fmohconnect.gov.ng/covid19_health_service_uptake/index.html" style="text-decoration: underline; font: Bold 12px Open Sans; letter-spacing: 0.16px; color: #24397D;" >Health service uptake Dashboard.</a>
          </span>
          <span style="float:right; ">
            <button @click="nhmisMonthlyAlert = false">
              <v-icon style="font-size:120%">close</v-icon>
            </button>
          </span>

        </p>
      </div>



      <div class="chart-stage">
        <div class="arrow-placement" data-step="7" data-intro='<b>Downloading Charts</b><p>Click on this icon to download a chart from any section</p>'></div>
        <highcharts :options="highchart_options" ref="highcharts"></highcharts>
      </div>
    </div>
  </div>
</template>

<script>
  import Fullscreen from "vue-fullscreen/src/component.vue"
  import MultiSelect from 'vue-multiselect'
  import vueSlider from 'vue-slider-component';
  import {Carousel3d, Slide} from 'vue-carousel-3d';
  // import PlotlyVue from '@/components/Plotly';
  import str_limit from '@/assets/js-on/strlimit';
  import {chart_options2} from '@/assets/js-on/highchart_options'
  import {mapMutations} from 'vuex'
  import { setTimeout } from 'timers';
  import {eventBus} from "../../../../main.js"

  export default {
    name: 'lineChart',
    components: {Fullscreen, Carousel3d, Slide, MultiSelect, vueSlider},
    props: ['appData', 'meta_data', 'uncertaintyData', 'isToggleClickedVal', 'isIHMEtoggleClickedVal'],
    data() {
      return {
        fullscreen: false,
        theName: "Nigeria",
        highchart_options: chart_options2,
        lsData: JSON.parse(this.$ls.get('car_other_dataset')),
        estimatesData: JSON.parse(this.$ls.get('estimates_dataset')),
        metaData: JSON.parse(this.$ls.get('meta_data_dataset')),
        isDataLoadedFirstTime: false,
        ihme_sdg_available_truthyVal: false,
        searchTerm: '',
        componentType: "line",
        traceArray: [],
        selectedIndicator: 'Skilled attendance at delivery or birth',
        optionsIndicator: [],
        selectedState: 'National',
        nationalTarget: '',
        sdgTarget: '',
        optionStates: ["Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Benue", "Borno", "Bayelsa",
          "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "FCT", "Gombe", "Imo",
          "Jigawa", "Kaduna", "Kebbi", "Kano", "Katsina", "Kogi", "Kwara", "Lagos", "Nasarawa", "National",
          "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers", "Sokoto", "Taraba", "Yobe",
          "Zamfara"],
        selectedSource: ["MICS", "NDHS", "NARHS", "NMIS", "NNHS", "NHMIS",
"World Bank", "IHME", "WHO-GHO", "WUENIC", "PCCS", "UNAIDS", "NHSPSS", "NHA", "KDGHS", "NAIIS"],
        headerObj: {},
        clicked: false,
        IHMEtoggleClicked: false,
        data: [],
        tableColumnHeaderAttr: null,
        computeUncertaintyTruthVal: false,
        lineSelected: true,
        columnSelected: false,
        tableSources: [],
        plottedUncertainty: [],
        confirmParentSource: [],
        toggleClicked: [],
        nhmisMonthlyAlert:false
      }
    },
    methods: {
      toggle() {
        // this.$refs['fullscreen'].background = "green";
        this.$refs['fullscreen'].toggle();
      },
      enter() {
        return true
      },
      changeChart(chart) {
        if(chart === 'line') {
          this.lineSelected = true;
          this.columnSelected = false;
          this.componentType = 'line'
        } else {
          this.lineSelected = false;
          this.columnSelected = true;
          this.componentType = 'column'
        }
      },
    //   compareIndicators(e) {
    //     this.$emit('compareIndicators', true);
    //   },
      getDisplayFactor(){
        //Get display factor for the line chart (e.g percentage, per 1000, per 100,000 etc)
        let displayFactor = '';
          for(const i in this.metaData){
            if(this.metaData[i][0] === this.selectedIndicator){
              displayFactor = this.metaData[i][3]
              break;
            }
          }
        this.highchart_options.yAxis.title.text = displayFactor;
      },

      plotUncertainty(e) {
        this.computeUncertaintyTruthVal = !this.computeUncertaintyTruthVal;
        //this.$emit('plotUncertainty', this.computeUncertaintyTruthVal);
      },
      getValue() {
        //Compute data object to map states name to arraylist
        var indicatorAndSourceValueByState = {};
        var statesAndRegions = this.$store.state.CAR.optionStates2
        statesAndRegions.map((elem, index) => {
          indicatorAndSourceValueByState[elem] = [];
          var data = this.estimatesData.slice(1)
          data.forEach((el) => {
            if(el[1] === elem){
                indicatorAndSourceValueByState[elem].push(el)
            }
          })
        })
        return indicatorAndSourceValueByState
      },
      extractUncertaintyData(indexOfindicatorSource, stateByIndicatorByYear) {
        let lineChartData = [];
        let finalLinechartData = [];
        let xAxis = [], yAxis = [];
        let statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
        let selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
        var sourceStateYearsVals = selectedStateByIndicatorByYear.map((elem2, index2) => {
          return [elem2[0], elem2[indexOfindicatorSource]];
        });
        for (var i in stateByIndicatorByYear[this.selectedState]) {
          lineChartData.push([stateByIndicatorByYear[this.selectedState][i][0],stateByIndicatorByYear[this.selectedState][i][indexOfindicatorSource]])
        }
        lineChartData.map((elem) => {
            let tempArray = [];
            let tempObj = {};
            let splittedArray = [];
            // console.log(elem);

            if(elem[1].indexOf('#')>-1){
              /*Spread the elements of the array after splitting with '#'
              (... is an ES6 syntax for spread)*/

              splittedArray = [...elem[1].split('#')];
              for(var i in splittedArray){
                  splittedArray[i] = parseFloat(splittedArray[i]);
              }
              tempArray = [elem[0],...splittedArray]
              tempObj = {
                year: elem[0],
                lb: splittedArray[0],
                ub: splittedArray[1]
              }
              finalLinechartData.push(tempObj);

            }

        });
        //To fill up empty spaces upto 1990 with null
        // for(var i=0; i<4; i++){
        //     // finalLinechartData.unshift(null);
        // }
        // finalLinechartData.unshift(null);
        return finalLinechartData
      },
      plotStateChart() {
        this.nhmisMonthlyAlert = false;
         if(this.tableSources == 'NHMIS-DHIS2 (monthly)'){
            this.plotNhmisMonthly(this.selectedIndicator);
         }
         else{


        let _vm = this;
        let longestChartData = 0;
        let availableYears = [];
        let nationalLongestChartDataArray = [],
        sdgLongestChartDataArray      = [];
        this.ihme_sdg_available_truthyVal = false;
        let nationalTarget;
        let sdgTarget;

        this.meta_data.map((elem) => {
          if(this.selectedIndicator == elem[0]){
            nationalTarget = elem[7]
            sdgTarget = elem[10];
            this.nationalTarget = nationalTarget === "" ? null : nationalTarget;
            this.sdgTarget = sdgTarget === "" ? null : sdgTarget;
          }
        });
        this.data = [];
        var statesByIndicatorByYear = this.$store.getters.getCurrentIndicatorsValue;
        var selectedStateByIndicatorByYear = statesByIndicatorByYear[this.selectedState];
        var data_trace = [];
        this.highchart_options.series = [];
        this.highchart_options.tooltip.headerFormat = '<span style="font-size:11px"><b>{point.key}</b></span><br>';
        this.highchart_options.tooltip.crosshairs = true;
        this.highchart_options.tooltip.shared = true;
        this.highchart_options.exporting= {
                    buttons: {
                        contextButton: {
                           menuItems: [
                              "printChart",
                              "separator",
                              "downloadPNG",
                              "downloadJPEG",
                              "downloadPDF",
                              "downloadSVG",
                              "separator",
                              "downloadCSV",
                              "downloadXLS",
                              //"viewData",
                              "openInCloud"],

                            symbol: 'download',
                            // symbolStrokeWidth: 2,
                            // symbolFill: '#330033',
                            // symbolStroke: '#b3d4fc'
                        }
                    },
                    filename: this.selectedIndicator,
                }
        // this.highchart_options.tooltip.pointFormat = '<span style="color:{point.color}"><b>{series.name}</b></span>: <b>{point.y:.2f}</b><br/>'
        var uncertainty_data
        this.tableSources.map((elem, index) => {
          var indicatorSource = this.selectedIndicator + ' -> ' + elem;
          if (this.lsData[0].indexOf(indicatorSource) > 0) {
            var indexOfindicatorSource = this.lsData[0].indexOf(indicatorSource) - 1;
            var sourceStateYearsVals = selectedStateByIndicatorByYear.map((elem2, index2) => {
              return [elem2[0], elem2[indexOfindicatorSource]];
            });
            var xAxis = [], yAxis = [];




            // Remove years with empty data

            sourceStateYearsVals.map((elem3, index3) => {

              if(elem3[1] !== ""){
                // xAxis.push(elem3[0]);
                // yAxis.push(elem3[1]);
              yAxis.push(elem3);


              }


            });

            yAxis.map((e, i)=>{
              if(!availableYears.includes(e[0])){
                availableYears.push(e[0])
              }
            })



            var series_data
            // var range_data
            series_data = {
              name: elem,
              data: yAxis,
              zoneAxis: "x",
              tooltip:{
                pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
              },

            }


//This block of code iterates through the series to be plotted and removes the sources that have no data. This fix was necessary because some datasets have national data but no state data. On selecting any state in such datasets, the legend still contains sources with no state data (but have national data) even though they are not plotted on the chart.
            this.highchart_options.series.push(series_data);
            for( var i = 0; i < this.highchart_options.series.length; i++){
                if ( this.highchart_options.series[i].data.length < 1) {
                  this.highchart_options.series.splice(i, 1);
                  i--;
                }
              }

 var maxArray = [];

            // for( var i = 0; i < this.highchart_options.series.length; i++){
            //   for(var j =0; j < this.highchart_options.series[i].data.length; j++) {

            //                     //console.log(this.highchart_options.series[i].data[j][1]);
            //                    maxArray.push(this.highchart_options.series[i].data[j][1]);

            //   }
            // }

            //  //console.log(maxArray);
            //  var max = Math.max(...maxArray);
            //  console.log(max);
            //  console.log(this.nationalTarget);

            // if (max <= this.nationalTarget){
            //   this.highchart_options.yAxis.max = this.nationalTarget+5;
            // }
            // else{
            //   this.highchart_options.yAxis.max = max+5;
            // }



            this.highchart_options.chart.events.load = function() {
              setTimeout(() => {
                _vm.$emit('chartRendered', true);
              }, 0);
            }



            // this.highchart_options.xAxis.min = minimumVal;     //Remove negative from line chart
          }
        });

        availableYears.sort(function(a, b){return a - b});

        availableYears.map((year)=>{
          nationalLongestChartDataArray.push([year,this.nationalTarget]);
          sdgLongestChartDataArray.push([year,this.sdgTarget])

          }
        );


        var ivt = this.$store.state.CAR.indicatorAttributesOtherSources[this.selectedIndicator];
        var vt = ivt[1] === "P" ? "%" : "";
        var it = ivt[1] === "P" ? "% of total" : "";

        // if (vt === '%') {
        //   this.highchart_options.yAxis.tickInterval = 25;
        // } else {
        //   this.highchart_options.yAxis.tickInterval = null;
        // }
        this.highchart_options.yAxis.plotLines = [];
        let nationalTargetLine = {
          id: 'nationalLineID',
          color: '#222222',
          width: 0.5,
          value: this.nationalTarget,
          label: {
            text: 'NT : ' + this.nationalTarget + vt, // vt is value type; whether percentage or number
            align: "right",
            rotation: 90,
            y: 25,
            x: -5
          }
        };

        let sdgTargetLine = {
          id: 'sdgLineID',
          color: '#222222',
          width: 0.5,
          value: this.sdgTarget,
          dashStyle: 'longdashdot',
          label: {
            text: 'SDG: ' + this.sdgTarget + vt, // vt is value type; whether percentage or number
            align: "right",
            rotation: 0,
            y: 12,
            x: -10
          }
        };

        if (this.componentType === 'line') {
          if (this.nationalTarget !== null) {
            let nationalPlotLinesSeries = {
              name: 'National Target',
              data: nationalLongestChartDataArray,
              // color: '#444444',
              color: '#2F4F4F',
              label:{
                enabled: true
              },
              lineWidth: 0.5,
              marker: {
                enabled:false
              },
              tooltip:{
                pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
              },
            }

            // this.highchart_options.series.push(nationalPlotLinesSeries);
          }
          if (this.sdgTarget !== null) {
            let sdgPlotLinesSeries = { 
              name: 'SDG Target',
              data: sdgLongestChartDataArray,
              color: '#444444',
              lineWidth: 0.5,
              dashStyle: 'longdashdot',
              marker: {
                enabled:false,
              },
              tooltip:{
                pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
              },
            }

            this.highchart_options.series.push(sdgPlotLinesSeries)
          }
          this.highchart_options.yAxis.plotLines.push(nationalTargetLine,sdgTargetLine);
        } else {
          this.highchart_options.yAxis.plotLines.push(nationalTargetLine,sdgTargetLine);
        }
        if (longestChartData > 45) {
          this.highchart_options.xAxis.tickInterval = 3;
        } else {
          this.highchart_options.xAxis.tickInterval = 1;
        }


        }

      },


      plotNhmisMonthly(indicator){
      let nhmisMonthlyData  =  this.$store.state.CAR.NhmisMonthlyData;
      let index = nhmisMonthlyData[0].indexOf(indicator + " -> " + "NHMIS");
      // let currentDate = latestData[0][0];
      let currentData = nhmisMonthlyData.filter(val => val[1] == this.selectedState);
      let lastFiveMonths = currentData.slice(Math.max(currentData.length - 12, 0));

      let data = lastFiveMonths.map(element => {
        let elem;
       return elem = [element[0],element[index]];
      });

        this.highchart_options.series = [];
        this.highchart_options.tooltip.headerFormat = '<span style="font-size:11px"><b>{point.key}</b></span><br>';
        this.highchart_options.tooltip.crosshairs = true;
        this.highchart_options.tooltip.shared = true;
        this.highchart_options.exporting= {
              enabled: false,
              buttons: {
                  contextButton: {
                      menuItems: [
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"],

                      symbol: 'download',
                      // symbolStrokeWidth: 2,
                      // symbolFill: '#330033',
                      // symbolStroke: '#b3d4fc'
                  }
              },
              filename: this.selectedIndicator,
        };

        let series_data = {
            name: this.tableSources,
            data: data,
            zoneAxis: "x",
            tooltip:{
              pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f}</b><br/>'
        },
      }
        this.nhmisMonthlyAlert = true
        this.highchart_options.xAxis.title.text = 'Month';
        this.highchart_options.series.push(series_data);

      },



      plotUncertaintyChart(source, addTruthy){
        this.plotStateChart();
        if(addTruthy) {
          this.plottedUncertainty.push(source);
        } else {
          let uncertIndex = this.plottedUncertainty.indexOf(source);
          if(uncertIndex > -1) {
            this.plottedUncertainty.splice(uncertIndex, 1);
          }
        }
        let two;

        if(this.plottedUncertainty.length > 0) {
          if (this.componentType === 'line') {
            this.plottedUncertainty.forEach((el) => {
              this.highchart_options.tooltip.crosshairs = true;
              this.highchart_options.tooltip.shared = true;
              let indicatorSource = this.selectedIndicator + ' -> ' + el;
              let indexOfindicatorSource = this.estimatesData[0].indexOf(indicatorSource);
              let uncertainty_value = this.getValue();
              let uncertainty_dataObj = this.extractUncertaintyData(indexOfindicatorSource, uncertainty_value);
              let uncertainty_data = uncertainty_dataObj.map(row => [row.year,Number(row.lb.toFixed(2)), Number(row.ub.toFixed(2))])
              //console.log(uncertainty_data);
              //console.log(typeof(uncertainty_data[0][1]))
              two = {
                name: `${el} confidence range`,
                data: uncertainty_data,
                type: 'arearange',
                lineWidth: 2,
                //linkedTo: ':previous',
                // color: this.$Highcharts.getOptions().colors[0],
                fillOpacity: 0.1,
                zIndex: 0,
                tooltip:{
                  formatter () {
                    const pointData = uncertainty_dataObj.find(row => row.year === this.point.x)

                  },
                  // pointFormat: '<span style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;"><b>{series.name}</b></span>: <b style="color:{point.color}; font-size: 11px; font-family: \'Open Sans\', sans-serif;">{point.y:.2f} - {const pointData = uncertainty_dataObj.find(row => row.year === this.point.x); pointData.ub}</b><br/>'

                },
                marker: {
                  enabled: true,
                  radius: 2,
                  lineWidth: 1,
                  width: 1
                },

                // zoneAxis: "x",
                // zones: [{
                //   value: 34
                // }, {
                //   dashStyle: "Dot",
                //   lineWidth: 0
                // }]
              }
              // this.plotStateChart();

              //console.log(two);

              for( var i = 0; i < this.highchart_options.series.length; i++){
                if ( this.highchart_options.series[i].name !== source) {
                  this.highchart_options.series.splice(i, 1);
                  i--;
                }
              }


              this.highchart_options.series.push(two);
              //console.log(source);
              //console.log(this.highchart_options.series);

            });
          }
        }
      },





      checkPlotMaxRange(yAxis) {
        var maxValForRangeSup = Math.max.apply(null, yAxis);
        if (maxValForRangeSup > 100) {
          this.layout.yaxis.range = [0, maxValForRangeSup % 10 === 0 ? maxValForRangeSup : maxValForRangeSup + maxValForRangeSup % 10];
          this.layout.yaxis.dtick = (maxValForRangeSup + maxValForRangeSup % 10) / 5;
        } else {
          this.layout.yaxis.range = [0, 100];
          this.layout.yaxis.dtick = 25;
        }
      }
    },
    computed: {
      sourceClicked() {
        this.tableSources = [];
        let tempSource = this.$store.getters.getTableSourceClicked;
        // this.tableColumnHeaderAttr = this.$store.getters.getSourceClicked;
        // var source = this.tableColumnHeaderAttr[0];
        // var val = this.tableColumnHeaderAttr[1];
        // var carSources = this.$store.getters.getCarSources;
        // var selectedSource = [source]; // ? [source]: carSources;
        // if (!val) {
        //   selectedSource = carSources
        // }
        if (Array.isArray(tempSource)){
          this.tableSources = tempSource;
        } else {
          this.tableSources.push(tempSource);
        }

        return tempSource;
      },
      indicatorSelected() {
        this.selectedIndicator = this.$store.getters.getSelectedIndicator;

        var temp = this.$store.getters.getShortIndicatorNames(this.selectedIndicator);
        return str_limit(temp, 80);
      },
      stateSelected() {
        this.selectedState = this.$store.getters.getSelectedState;
        return this.selectedState;
      }
    },
    created() {
      eventBus.$on("changedStateName", (data) => {
          this.theName = data;
      })
      this.highchart_options.chart.type = 'line';
      this.highchart_options.plotOptions.line = {
        dataLabels: {
          enabled: false,
        }
      }

      this.highchart_options.title.text = ''
      this.highchart_options.series = []
      this.highchart_options.subtitle.text = '';
      this.highchart_options.legend = {
        // layout: 'vertical',
        // align: 'right',
        verticalAlign: 'top',
        x: -20,
        y: 0,
        itemStyle: {
          fontSize: '12px',
          fontFamily: '"Open Sans", sans-serif',
          fontWeight: '600',
          color: '#333'
        }
        // floating: false,
        // borderWidth: 1,
        // shadow: true
      };
      this.highchart_options.xAxis.title.text = 'Year';
      this.highchart_options.tooltip.crosshairs = false;
      this.highchart_options.tooltip.shared = false;
      // this.highchart_options.yAxis.title.text = '';
      // this.highchart_options.plotOptions.series = {
      //   cursor: 'pointer',
      //   dashStyle: "LongDash",
      //   point: {
      //   },
      //   marker: {
      //     lineWidth: 1
      //   }
      // }
      this.highchart_options.plotOptions.colorByPoint = true;
      this.highchart_options.chart.height = 317;
    },
    mounted() {
      if(this.$route.params.indicator && this.$route.params.state){
        this.selectedIndicator = this.$route.params.indicator;
        this.selectedState = this.$route.params.state;
      } else {
        this.selectedIndicator = 'Skilled attendance at delivery or birth';
        this.selectedState = 'National';
      }
      // call get indicator to get indicators
      if (this.lsData) {
        // this.isDataLoadedFirstTime = true;
        this.plotStateChart();
      }
      if(this.metaData){
        this.getDisplayFactor();
      }

    },
    updated() {
    },
    watch: {
      selectedIndicator(val) {
        if (this.lsData) {
          setTimeout(() => {
            this.plotStateChart();
          },5);
        }
        if(this.metaData){
          this.getDisplayFactor();
        }
        this.plottedUncertainty = [];
      },
      selectedState(val) {
        if (this.lsData) {
          this.plotStateChart();
        }
        this.plottedUncertainty = [];
      },
      selectedSource(val) {
        if (this.lsData) {
          this.plotStateChart();
        }
      },
      uncertaintyData(val) {
        this.estimatesData = val;
        // this.plotStateChart();
        //this.$store.dispatch('storeEstimateSourceData', {list: val});
      },
      componentType(val) {
        if (val === 'column') {
          this.highchart_options.plotOptions.series.pointWidth = 4;
          this.plotStateChart()
        }
        else {
          this.plotStateChart()
        }
        this.highchart_options.chart.type = val;
      },
      tableSources(val){
        if (this.lsData) {
          this.plotStateChart();
        }
      },
      appData(val) {
        this.lsData = val;
        this.isDataLoadedFirstTime = true;
        this.plotStateChart();
        // call method ...
      },
      isToggleClickedVal(val) {
        this.toggleClicked = val;
      },

      toggleClicked(val){
        this.clicked = val[0];
        // console.log(val);

        if(val[0] === true){
          this.plotUncertaintyChart(val[1], true);
          this.confirmParentSource.push(val[1])
          // console.log(this.confirmParentSource);

        } else {
          // this.plotStateChart();
          this.plotUncertaintyChart(val[1], false);

          let index = this.confirmParentSource.indexOf(val[1]);
          this.confirmParentSource.splice(index, 1);
        }
      },
      meta_data(val){
        if(val){
          this.metaData = val;
          this.getDisplayFactor();
        }
      }
    }
  }

</script>

<style scoped>
  div[class^="col"] {
    padding-left: 7px;
    padding-right: 7px;
  }

  /* Some styles live in App.vue file*/
</style>



// WEBPACK FOOTER //
// lineChart.vue?5e8ce36c